// assets
import monaSans700Latin from '@fontsource/mona-sans/files/mona-sans-latin-700-normal.woff2?url'
import inter400Latin from '@fontsource/inter/files/inter-latin-400-normal.woff2?url'
import inter500Latin from '@fontsource/inter/files/inter-latin-500-normal.woff2?url'
import inter600Latin from '@fontsource/inter/files/inter-latin-600-normal.woff2?url'

const PRELOADED_FONTS = [monaSans700Latin, inter400Latin, inter500Latin, inter600Latin]

export default defineNuxtPlugin(() => {
  useHead({
    link: PRELOADED_FONTS.map(href => ({
      rel: 'preload',
      as: 'font',
      type: 'font/woff2',
      href,
      crossorigin: 'anonymous',
    })),
  })
})
